export default __webpack_public_path__ + "static/media/problemsolver.3f594a4f.svg";